import { render, staticRenderFns } from "./GameState.vue?vue&type=template&id=3c490c67&"
import script from "./GameState.vue?vue&type=script&lang=js&"
export * from "./GameState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports